<template>
	<page>
		<module>
			<view-list work-type="53" ref="view" selector :view-config="auth('b_order_return_viewmanage')">
				<template #search>
					<m-search ref="search">
						<m-search-item label="退货单号">
							<c-input name="return_code"></c-input>
						</m-search-item>
						<m-search-item label="状态">
							<c-select name="states" :options="approvalStateDic" multiple></c-select>
						</m-search-item>
						<m-search-item label="销售订单">
							<c-input name="order_number"></c-input>
						</m-search-item>
						<m-search-item label="客户">
							<c-select name="customer_ids" async multiple @search="searchCustomer"></c-select>
						</m-search-item>
						<m-search-item label="产品信息">
							<c-input name="product_info" placeholder="支持产品编号/名称/规格"></c-input>
						</m-search-item>
						<m-search-item label="创建时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button color="main" v-if="auth('b_order_return_create')" v-lock="lock('b_order_return_create')" prepend-icon="tf-add" @click="editOrder()">创建退货单</c-button>
					<c-button v-if="auth('b_order_return_export')" v-lock="lock('b_order_return_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_order_return_export')" v-lock="lock('b_order_return_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
				</template>

				<template #batchOperate="{data}">
					<c-button v-if="auth('b_order_return_export')" v-lock="lock('b_order_return_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_order_return_export')" v-lock="lock('b_order_return_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
					<c-button v-if="auth('b_order_return_print')" v-lock="lock('b_order_return_print')" prepend-icon="tf-print" @click="$refs.view.batchExportByTemplate()">打印</c-button>
				</template>

				<template #otherOperate>
					<c-button v-if="auth('b_order_return_log')" v-lock="lock('b_order_return_log')" prepend-icon="tf-operate-record" @click="$refs.view.loadWorkLogDetail()">操作记录</c-button>
				</template>

				<template #return_code="{data}">
					<c-link @click="globalDialog('orderReturnDetail', {props: {id: data.id}})">{{data.return_code}}</c-link>
				</template>

				<!--状态-->
				<template #state="{data}">
					<c-state dict="approvalStateDic" tag :value="data.state"></c-state>
				</template>

				<!--退货订单 -->
				<template #orders="{data}">
					<order-link type="order" :data="data.orders"></order-link>
				</template>

				<!--退货仓库 -->
				<template #warehouse_id="{data}">
					{{data.warehouse_name}}
				</template>

				<c-table-column
					type="button"
					label="操作"
					width="228"
					button-limit="4"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_order_return_edit')" :disabled="!(data.state == 1)" v-lock="lock('b_order_return_edit')" icon="tf-trash" @click="editOrder(data.id)">编辑</c-table-button>
						<c-table-button v-if="auth('b_order_return_query')" v-lock="lock('b_order_return_query')" icon="tf-detail" @click="globalDialog('orderReturnDetail', {props: {id: data.id}})">查看</c-table-button>
						<c-table-button v-if="auth('b_order_return_state_ok') && data.state == 1" v-lock="lock('b_order_return_state_ok')" icon="tf-finish" @click="editState(data, 2)">核准</c-table-button>
						<c-table-button v-if="auth('b_order_return_state_no') && data.state == 2" v-lock="lock('b_order_return_state_no')" icon="tf-cancel" @click="editState(data, 1)">反核准</c-table-button>
						<c-table-button v-if="auth('b_order_return_print')" v-lock="lock('b_order_return_print')" icon="tf-print" @click="$refs.view.exportByTemplate(data.id)">打印</c-table-button>
						<c-table-button v-if="auth('b_order_return_delete')" :disabled="!(data.state == 1)" v-lock="lock('b_order_return_delete')" icon="tf-trash" color="red" @click="removeOrder(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</view-list>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'

	export default {
		data() {
			return {
			}
		},

		computed: {
			// 获取dictName选项数据
			...mapState(['approvalStateDic'])
		},

		methods: {
			/*******搜索【客户】下拉框信息*****************/
			searchCustomer(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'CUSTOMER',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},

			/******新建/编辑退货单*******/
			editOrder(data) {
				this.globalDialog('orderReturnEdit', {
					data: {
						returnId: data
					}
				}, this.$refs.view.update);
			},

			/******修改退货单核准状态************/
			editState(data, state){
				var message = '确认核准退货单【'+data.return_code+'】？核准后将自动生成关联入库单';
				if(state == 1){
					message = '确认反核准退货单【'+data.return_code+'】？反核准后将删除关联入库单';
				}
				this.$confirm({
					message: message,  // 提示内容,
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/order/return/editState',
							data: {
								id: data.id,
								state: state,
							},
							loading: true,
							success: data => {
								var mess = '';
								if(state == 1){
									mess = '反核准成功';
								}else if(state == 2){
									mess = '核准成功';
								}

								this.$message({
									message: mess,  // 提示内容,
									type: 'success'
								});
								//刷新
								this.$refs.view.refresh();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

			/******删除退货单************/
			removeOrder(data){
				this.$confirm({
					message:'确认删除退货单【'+data.return_code+'】？删除后不可恢复',  // 提示内容,
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/order/return/delete',
							data: {id:data.id},
							loading: true,
							success: data => {
								this.$message({
									message:'删除成功',  // 提示内容,
									type: 'success'
								});
								//刷新
								this.$refs.view.refresh();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
